import { MotionConfig, m } from 'framer-motion';

const AnimatedTabs = ({ layoutKey, tabs = [], tab, setTab, className, disabled = false }) => {
  return (
    <MotionConfig transition={{ type: 'spring', duration: 0.2, bounce: 0 }}>
      <m.ul layout className={`comp-animated-tabs ${className}`}>
        {tabs?.map((n) => (
          <m.li layout className={`tab-item ${tab === n?.value ? 'active' : ''} ${disabled ? 'disabled' : ''}`} tabIndex={0} key={n?.value} onClick={disabled ? null : () => setTab(n?.value)}>
            {tab === n?.value ? <m.div layoutId={`tab-indicator-${layoutKey}`} className={'tab-indicator'} /> : null}
            <span className={'tab-text'}>
              {n.label}
              {n?.count > 0 && <span className={'tab-count'}>{n?.count}</span>}
            </span>
          </m.li>
        ))}
      </m.ul>
    </MotionConfig>
  );
};

export default AnimatedTabs;
